import { __decorate } from "tslib";
import '@power-elements/stripe-elements';
import { html, css, LitElement } from 'lit';
import { property } from 'lit/decorators.js';
import { Bulma } from '@skhemata/skhemata-css';
export class SkhemataFormStripe extends LitElement {
    constructor() {
        super(...arguments);
        this.submitDisabled = false;
        this.publishableKey = '';
    }
    onChange(e) {
        this.submitDisabled = !(e.target.complete && !e.target.hasError);
    }
    onClick() {
        var _a;
        const stripe = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('stripe-elements');
        stripe === null || stripe === void 0 ? void 0 : stripe.createSource();
    }
    onSource(e) {
        this.source = e.detail.source;
    }
    onError(e) {
        this.error = e.target.error;
    }
    firstUpdated() {
        var _a;
        this.stripeElements = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('stripe-elements');
    }
    render() {
        return html `
    <div class="field">
      <label class="label"></label>
      <div class="control">
        <stripe-elements
          hide-postal-code = "true"
          publishable-key=${this.publishableKey}
        ></stripe-elements>
      </div>
    </div>
  </div>
    `;
    }
}
SkhemataFormStripe.styles = [
    Bulma,
    css `
      stripe-elements {
        --stripe-elements-base-line-height: 1.57rem;
        --stripe-elements-border: 1px solid #dbdbdb;
      }
    `,
];
__decorate([
    property({ type: Object })
], SkhemataFormStripe.prototype, "error", void 0);
__decorate([
    property({ type: Object })
], SkhemataFormStripe.prototype, "source", void 0);
__decorate([
    property({ type: Boolean })
], SkhemataFormStripe.prototype, "submitDisabled", void 0);
__decorate([
    property({ type: String, attribute: 'publishable-key' })
], SkhemataFormStripe.prototype, "publishableKey", void 0);
__decorate([
    property({ type: Object })
], SkhemataFormStripe.prototype, "stripeElements", void 0);
//# sourceMappingURL=SkhemataFormStripe.js.map